import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { renderCompactZoneBlock } from '../../utils/zoneUtils';
import { useTranslation } from '../../i18n';
import API_BASE_URL from '../../config/api';

const ZoneDistributionChartSwimming = ({ userId, fileId }) => {
  const { t } = useTranslation();
  const [heartRateData, setHeartRateData] = useState([]);
  const [swimData, setSwimData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId || !fileId) {
      setLoading(false);
      return;
    }
    const fetchZoneUsage = async () => {
      try {
        const fullFileId = fileId.endsWith('.fit') ? fileId : `${fileId}.fit`;
        const res = await axios.get(`${API_BASE_URL}/api/fit/zones-distribution/${userId}/${fullFileId}`);
        setHeartRateData(Array.isArray(res.data.heartRateZones) ? res.data.heartRateZones : []);
        setSwimData(Array.isArray(res.data.swimPaceZones) ? res.data.swimPaceZones : []);
      } catch (err) {
        console.error('Error al obtener zonas:', err);
        setError(t('athleteDashboard.zonesLoadingError'));
      } finally {
        setLoading(false);
      }
    };
    fetchZoneUsage();
  }, [userId, fileId, t]);

  if (error) return <p style={{ color: 'red' }}>{error}</p>;
  if (loading) return <p>{t('athleteDashboard.zonesCyclingLoading')}</p>;
  if (heartRateData.length === 0 && swimData.length === 0)
    return <p>{t('athleteDashboard.zonesCyclingNoData')}</p>;

  return (
    <div className="zone-distribution-chart">
      <h3 style={{ color: '#193255', fontSize: 14, fontWeight: 700 }}>{t('athleteDashboard.zonesCyclingSummary')}</h3>
      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', marginTop: 12 }}>
        {heartRateData.length > 0 && renderCompactZoneBlock(heartRateData, t('athleteDashboard.zonesHR'), t, 'zoneFC')}
        {swimData.length > 0 && renderCompactZoneBlock(swimData, t('athleteDashboard.zonesSwimPace'), t, 'zoneSWIM')}
      </div>
    </div>
  );
};

export default ZoneDistributionChartSwimming;
